import {Routes} from '@angular/router';
import {environment} from '@environment/environment';
import {AuthLayoutComponent} from '@layout/auth-layout/auth-layout.component';
import {AUTH_LAYOUT_ROUTES} from '@core/routes/auth-layout.routes';
import {FullLayoutComponent} from '@layout/full-layout/full-layout.component';
import {FULL_LAYOUT_ROUTES} from '@core/routes/full-layout.routes';
import {AuthGuard} from '@guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: environment.home_page,
    pathMatch: 'full',
  },
  {path: '', component: AuthLayoutComponent, data: {title: 'content Views'}, children: AUTH_LAYOUT_ROUTES},
  {path: '', component: FullLayoutComponent, data: {title: 'content Views'}, children: FULL_LAYOUT_ROUTES, canActivate: [AuthGuard]}
];
